import { render, staticRenderFns } from "./sparePartsDetail.vue?vue&type=template&id=61288e76&scoped=true&"
import script from "./sparePartsDetail.vue?vue&type=script&lang=js&"
export * from "./sparePartsDetail.vue?vue&type=script&lang=js&"
import style0 from "./sparePartsDetail.vue?vue&type=style&index=0&id=61288e76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61288e76",
  null
  
)

export default component.exports